module.exports = __webpack_public_path__ + "assets/img/tx388_4.0ec8a5da.jpg";